import Machine from "../agroImg/mechI.png";
import Shipping from "../agroImg/shipO.png";
import Maintain from "../agroImg/maintain.png";
import Help from "../agroImg/userH.png";

export const ServiceData = [
  {
    img: Machine,
    title: "Machinery Provider",
    details:
      "We provide a platform where you buy various machines & equipments ranging from Tractors, bulldozers, harvesters,",
  },
  {
    img: Shipping,
    title: "Export Services",
    details:
      "We offer export services on our machinery to our international customers, we can also take care of the paper work.",
  },
  {
    img: Maintain,
    title: "Maintenance Service",
    details:
      "We are able to offer Worldwide maintenane services using experienced professionals to provides quality services",
  },
  {
    img: Shipping,
    title: "Shipping Options",
    details:
      "We are able to offer worldwide shipping options using experienced hauliers to ensure the highest quality service",
  },
  {
    img: Maintain,
    title: "Hire Services",
    details:
      "We provide a platform where you buy various machines & equipments ranging from Tractors, bulldozers, harvesters,",
  },
  {
    img: Help,
    title: "Help Center",
    details:
      "We provide a platform where you buy various machines & equipments ranging from Tractors, bulldozers, harvesters,",
  },
];
